import { createApp } from 'vue'

/**
 * Creates a Vue instance for each element matching the selector.
 * @param {string} selector - CSS selector
 * @param {Object} options - Vue instance options
 * @param {function} setup - Optional setup function to execute on Vue instance
 */
function createVueInstance(selector, options, setup) {
  const elements = Array.from(document.querySelectorAll(selector))
  
  elements.forEach(element => {
    const app = createApp(options)
    if (setup) {
      setup(app)
    }
    
    app.mount(element)
  })
}

// Import components
import LeavingSiteNotice from './components/LeavingSiteNotice.vue';

// Create Vue instances
createVueInstance(
  '.vue-leaving-site-notice',
  {
    components: {
      LeavingSiteNotice
    }
  }
);